import {
  API_BASE_SRC,
  BASE_PATH,
  CONSULTA_INDIVIDUO_NEGATIVO,
  GUARDAR_DATOS_CONTACTO
} from "@/config/constants/end-points";

describe("End-points Constants Test", () => {
  it("should have the correct value for API_BASE_SRC", () => {
    expect(API_BASE_SRC).toEqual(undefined);
  });

  it("should have the correct value for BASE_PATH", () => {
    expect(BASE_PATH).toEqual(undefined);
  });

  it("should have the correct value for CONSULTA_INDIVIDUO_NEGATIVO", () => {
    expect(CONSULTA_INDIVIDUO_NEGATIVO).toEqual(
      "/contacto/empresas/consultaIndividuoNegativo"
    );
  });

  it("should have the correct value for GUARDAR_DATOS_CONTACTO", () => {
    expect(GUARDAR_DATOS_CONTACTO).toEqual(
      "/contacto/empresas/guardarDatosContacto"
    );
  });
});
